import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { RouterProvider } from 'react-router';

import { installGlobalJobErrorReporting } from '@/features/custodial/services/jobErrorReporter';

import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { ToastContainer } from './components/ui/toast';
import { VersionBanner } from './components/VersionBanner';
import { OAuthProvider, SignInDialog } from './features/auth';
import OAuthAccountBindingDialog from './features/auth/components/OAuthAccountBindingDialog';
import { FlowChoiceDialog } from './features/flow';
import { MigrationDialog } from './features/migration';
import PasskeyManagementDialog from './features/tradingSession/components/PasskeyManagementDialog';
import OAuthAuthorityBridge from './features/tradingSession/OAuthAuthorityBridge';
import TradingSessionProvider from './features/tradingSession/TradingSessionProvider';
import WalletSwitchBridge from './features/wallet/switchGuard/WalletSwitchBridge';
import WalletSwitchDialog from './features/wallet/switchGuard/WalletSwitchDialog';
import { queryClient } from './lib/query';
import router from './router';

installGlobalJobErrorReporting();

const App: React.FC = () => (
    <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
            <OAuthProvider>
                <TradingSessionProvider>
                    <OAuthAuthorityBridge />
                    <WalletSwitchBridge />
                    <RouterProvider router={router} />
                    <SignInDialog />
                    <FlowChoiceDialog />
                    <MigrationDialog />
                    <OAuthAccountBindingDialog />
                    <PasskeyManagementDialog />
                    <WalletSwitchDialog />
                    <ToastContainer />
                    <VersionBanner />
                </TradingSessionProvider>
            </OAuthProvider>
        </QueryClientProvider>
    </ErrorBoundary>
);
App.displayName = 'App';
export default App;
